module.exports = __webpack_public_path__ + "static/media/trash-icon.fbe40f97.svg";